/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaButtonWithText/view.blocks to change it.
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function TysiaButtonWithText({
  children,
  viewPath = "/DesignSystem/TysiaButtonWithText",
  width,
  justifyContent,
  marginLeft,
  marginRight,
  marginTop,
  marginBottom,
  onClick,
  disabled,
  type,
  size,
  innerRef,
  alignSelf,
  text
  
}) {
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 width={width}
 justifyContent={justifyContent}
 marginLeft={marginLeft}
 marginRight={marginRight}
 marginTop={marginTop}
 marginBottom={marginBottom}
 onClick={onClick}
 disabled={disabled}
 type={type}
 size={size}
 innerRef={innerRef}
 alignSelf={alignSelf}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text={text}
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}